import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE, ATTRS_VALUE_TYPES_TRANSLATE } from 'src/app/constants/preset-element-actions';
import { ReferenceParams } from 'src/app/models';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';
import { ApiPresetsService } from 'src/app/services/api-presets.service';

@Component({
  selector: 'app-filter-from-attribute',
  templateUrl: './filter-from-attribute.component.html',
  styleUrls: ['./filter-from-attribute.component.css']
})
export class FilterFromAttributeComponent implements OnInit {

  @Input() set data(value) {

    if (value != null) {

      console.log("VALUE WINDOW: ", value );
      
     
    //  this.filterData = value;
      this.initForm(value.params);

      if(!value.action) {

        this.filterForm.get('atribute_type').setValue('commercial')
      }
      
    }
  }

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();

  loading: boolean;
  attributeGroups: any[] = [];
  attributePresentationTypes: any = ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE;
  attributeValueTypes: any = ATTRS_VALUE_TYPES_TRANSLATE;
  getAuthor: any;
  // filterData: any;

  // список типов аттрибутов
  atributeTypes: any [] = [
    {
      key: 'default',
      value: 'Дефолтные'
    },
    {
      key: 'commercial',
      value: 'Коммерческие'
    },
    {
      key: 'all',
      value: 'Все'
    },
  ]

  // шкала заполнености
  occupancyScale: any [] = [
    {
      key: 'yes',
      value: 'ВКЛ'
    },
    {
      key: 'no',
      value: 'ВЫКЛ'
    },
    {
      key: 'all',
      value: 'Все'
    }
  ]

  // обязательность
  obligations: any [] = [
    {
      key: 'yes',
      value: 'Да'
    },
    {
      key: 'no',
      value: 'Нет'
    },
    {
      key: 'all',
      value: 'Все'
    }
  ]

  filterForm: UntypedFormGroup = this.fb.group({
    atribut:        [null],
    atribute_type:  [null],
    author:         [null],
    complete_scale: [null],
    group:          [null],
    type:           [null],
    format:         [null],
    obligation:     [null]
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private apiPresets: ApiPresetsService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');  
    
    // при первой загрузке подставляем в поле ТИП АТРИБУТА 'Коммерческие'
    // this.filterForm.get('atribute_type').setValue('commercial')
    
    this.getAttributeGroup();
    this.getUserOrgs();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  initForm(filterData): void {

    console.log(filterData);
    

    if(filterData) {

      this.filterForm.setValue({
        atribut:        filterData.attr_name,
        atribute_type:  filterData.type_attr,
        author:         filterData.author[0],
        complete_scale: filterData.scale,
        group:          filterData.attr_group[0],
        type:           filterData.type[0],
        format:         filterData.format[0],
        obligation:     filterData.mandatory
      });
    }
  }


  /**
   * 
   * @returns 
   */
  dataGenerate() {

    let filterFormData = {...this.filterForm.value}

    let data = {

      attr_name: this.filterForm.get('atribut').value,
      author: [this.filterForm.get('author').value],
      attr_group: [this.filterForm.get('group').value],
      type: [this.filterForm.get('type').value],
      mandatory: this.filterForm.get('obligation').value,
      type_attr: this.filterForm.get('atribute_type').value,
      scale: this.filterForm.get('complete_scale').value,
      format: [this.filterForm.get('format').value],

    }

    return data
  }


  /**
   * 
   */
  send() {

    let check: any[] = [];

    Object.values(this.filterForm.value).forEach(elem=>{
      
      if(elem != null){

        check.push(elem);
      }
    })

    let data = {
      value: this.dataGenerate(),
      check: check, 
      action: true
    }
    
    this.activeModal.close(data);
  }


  /**
   * 
   */
  resetFilterForm(): void {

    this.filterForm.reset();
  }



  /**
   * 
   */
  getAttributeGroup(): void {

    let params: ReferenceParams = {
      ref_name: 'attribute_groups',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributeGroups = response.result;
        }
      })
    );
  }


  /**
   * 
   */
  getUserOrgs(): void {

    this.subscriptions.add(
      this.apiPresets.getUserOrgs().subscribe((response: any) => {

        console.log('response', response);
        

        if (response != null) {

          this.getAuthor = response.result
          // this.attributeGroups = response.result;
        }
      })
    );
  }

}
